var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "url(#paint0_linear_1246_6029)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20.0003C19.1083 20.0003 20.4167 18.692 20.4167 17.0837C20.4167 15.4753 19.1083 14.167 17.5 14.167C15.8917 14.167 14.5833 15.4753 14.5833 17.0837C14.5833 18.692 15.8917 20.0003 17.5 20.0003ZM17.5 15.8337C18.1917 15.8337 18.75 16.392 18.75 17.0837C18.75 17.7753 18.1917 18.3337 17.5 18.3337C16.8083 18.3337 16.25 17.7753 16.25 17.0837C16.25 16.392 16.8083 15.8337 17.5 15.8337ZM17.5417 24.167H13.975C14.8 23.7503 16.225 23.3337 17.5 23.3337C17.5917 23.3337 17.6917 23.342 17.7833 23.342C18.0667 22.7337 18.5583 22.2337 19.15 21.8337C18.5417 21.7253 17.9667 21.667 17.5 21.667C15.55 21.667 11.6667 22.642 11.6667 24.5837V25.8337H17.5V24.5837C17.5 24.442 17.5167 24.3003 17.5417 24.167ZM23.75 22.0837C22.2167 22.0837 19.1667 22.9253 19.1667 24.5837V25.8337H28.3333V24.5837C28.3333 22.9253 25.2833 22.0837 23.75 22.0837ZM24.7583 20.567C25.3917 20.2087 25.8333 19.5337 25.8333 18.7503C25.8333 17.6003 24.9 16.667 23.75 16.667C22.6 16.667 21.6667 17.6003 21.6667 18.7503C21.6667 19.5337 22.1083 20.2087 22.7417 20.567C23.0417 20.7337 23.3833 20.8337 23.75 20.8337C24.1167 20.8337 24.4583 20.7337 24.7583 20.567Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1246_6029",
    x1: 0,
    y1: 0,
    x2: 40,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9700DE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.933cff38771aed0429840b53651af3db.svg";
export { ForwardRef as ReactComponent };